import ReactEChartsCore from '../EChart';
import * as echarts from 'echarts/core';
import { useAppContext } from '../../../providers/AppProvider';
import { TooltipComponent } from 'echarts/components';
import { PieChart } from 'echarts/charts';
echarts.use([TooltipComponent, PieChart]);

const getDefaultOptions = (getThemeColor, data = []) => ({
  color: [
    getThemeColor('info-300'),
    getThemeColor('warning-300'),
    getThemeColor('danger-300'),
    getThemeColor('success-300'),
    getThemeColor('primary'),
    getThemeColor('gray-400')
  ],
  tooltip: { trigger: 'item' },
  responsive: true,
  maintainAspectRatio: false,
  series: [
    {
      name: 'Materials',
      type: 'pie',
      radius: ['48%', '90%'],
      startAngle: 30,
      avoidLabelOverlap: false,
      label: {
        show: false,
        position: 'center',
        formatter: '{x|{d}%} \n {y|{b}}',
        rich: {
          x: {
            fontSize: 31.25,
            fontWeight: 800,
            color: getThemeColor('gray-700'),
            padding: [0, 0, 5, 15]
          },
          y: {
            fontSize: 12.8,
            color: getThemeColor('gray-700'),
            fontWeight: 600
          }
        }
      },
      emphasis: { label: { show: true } },
      labelLine: { show: false },
      data
    }
  ],
  grid: { bottom: 0, top: 0, left: 0, right: 0, containLabel: false }
});

const ProjectConsumptionDetailsChart = ({ data }) => {
  const { getThemeColor } = useAppContext();

  return (
    <ReactEChartsCore
      echarts={echarts}
      option={getDefaultOptions(getThemeColor, data)}
      style={{ minHeight: '300px', width: '100%' }}
    />
  );
};

export default ProjectConsumptionDetailsChart;
